export type IsConstructorExperience = boolean

// CONSTANTS
export const ConstructorExperienceConstants = {
  SET_CONSTRUCTOR_EXPERIENCE: 'SET_CONSTRUCTOR_EXPERIENCE',
}

// ACTION TYPES
export type ConstructorExperienceActionTypes = {
  type: typeof ConstructorExperienceConstants.SET_CONSTRUCTOR_EXPERIENCE
  payload: IsConstructorExperience
}

// ACTION CALLS
export const ConstructorExperienceActions = {
  SET_CONSTRUCTOR_EXPERIENCE: (
    payload: IsConstructorExperience
  ): ConstructorExperienceActionTypes => ({
    type: ConstructorExperienceConstants.SET_CONSTRUCTOR_EXPERIENCE,
    payload,
  }),
}
